import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FontWeight,
  Icon,
  IconVariant,
  Link,
  LinkVariant,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import { buildMenuExperienceCategoryHref } from './MenuExperienceCategoryNav'
import type { MenuExperienceNavItem } from './hooks/useMenuExperienceNavigation'

type ProspectBackLinkProps = {
  browse: MenuExperienceNavItem
  pathname?: string
  query: Record<string, unknown>
}

const BackRow = withCitrusTheme(Box, (theme) => ({
  boxSizing: 'border-box',
  height: theme.spacing(12),
  margin: '0 auto',
  padding: theme.spacing(3),
  [`@media (min-width: ${theme.tokens.breakpoints[3]})`]: {
    paddingLeft: '44px',
  },
}))

const BackLink = withCitrusTheme(Link, (theme) => ({
  alignItems: 'center',
  display: 'inline-flex',
  gap: `${theme.spacing(2)}px`,
  textDecoration: 'none',
  '&:focus-visible': {
    outline: `2px solid ${theme.color(Color.Secondary_400)}`,
    outlineOffset: '2px',
  },
}))

export const ProspectBackLink = ({ browse, pathname = '/menu', query }: ProspectBackLinkProps) => (
  <Box data-testid="prospect-back-link" bg={Color.White}>
    <BackRow display={Display.Flex} alignItems={AlignItems.Center} maxWidth="1600px">
      <BackLink
        href={buildMenuExperienceCategoryHref({ pathname, query, slug: browse.slug })}
        variant={LinkVariant.None}
        onClick={browse.onClick}
      >
        <Icon name="chevron_left" size={6} variant={IconVariant.Actionable} />
        <Text color={Color.Secondary_400} fontWeight={FontWeight.Bold} size={5}>
          Back
        </Text>
      </BackLink>
    </BackRow>
  </Box>
)
